import purchaseHistory from '../purchaseHistory'

export default {
    isLoggedIn: false,
    email: null,
    firstname: null,
    lastname: null,
    accupro_valid_until: false,
    accupro_subscriptions: {},
    delivery_country_id: null,
    language_iso_code: null,
    created_at: null,
    async load() {
        try {
            const { data } = await window.api.get('/api/user')

            this.email = data.email
            this.id_customer = data.id_customer
            this.firstname = data.firstname
            this.lastname = data.lastname
            this.isLoggedIn = true
            this.accupro_valid_until = data.accupro_valid_until
            this.language_iso_code = data.language_iso_code
            this.accupro_subscriptions = data.accupro_subscriptions
            this.company = data.company
            this.created_at = data.date_add

            // Initialise purchase history on login
            await purchaseHistory.getProductHistory(0)

            window.dispatchEvent(new CustomEvent('user-loaded'))
        } catch {
            // do nothing
        }
    },
    // The signed-in state is kept in localStorage, so it outlives the session (it expires, or the customer signs out
    // on another device), and index.js only asks /api/user while it says signed out. A page acting on it from a shared
    // (Cloudflare-cached) copy calls this once: if the server no longer knows them, forget it. Other errors keep it.
    async revalidate() {
        try {
            await window.api.get('/api/user')
        } catch (error) {
            if ([401, 403].includes(error?.response?.status)) {
                Object.assign(this, {
                    isLoggedIn: false,
                    email: null,
                    id_customer: null,
                    firstname: null,
                    lastname: null,
                    company: null,
                    accupro_valid_until: false,
                    accupro_subscriptions: {},
                    created_at: null,
                })
            }
        }
    },
}
